import React from "react";
import { Box } from '@mui/joy';
import { Pie, Table, Bar } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import { Filters, Overview } from ".";
import KPISet from "./KPISet";
import useFiltersFromLocation from "src/mtska-frontend-app-scaffolding/hooks/useFiltersFromLocation";
import { useDataProvider } from "src/mtska-frontend-data-provider";
import { useNavigate } from 'react-router-dom';
import PieFleet from "./RunningDashboard.PieFleet";
import PiePotential from "./RunningDashboard.PiePotential";
import PieAccounting from "./RunningDashboard.PieAccounting";
import PieExpiration from "./RunningDashboard.PieExpiration";
import PieTraceKM from "./RunningDashboard.PieTraceKM";
import PiePurchase from "./RunningDashboard.PiePurchase";

const RunningDashboard = React.forwardRef((props, ref) => {

    const showKPI = false;
    const showPIEFleet = false;
    const showPIEAccounting = false;
    const showPIEExpiration = false;
    const showPIETraceKm = false;
    const showPIEPurchase = false;
    const showPIEPotential = false;
    const showOverviewByRenter = false;
    const showOverviewByArea = false;
    const showOverviewByAccount = false;
    const showOverviewByCustomerCluster = false;
    const showTimelineExpiration = false;
    const showTimelineCommission = false;
    const showActionablesExpiration = false;
    const showActionablesKm = false;

    const { item: user } = useDataProvider('auth/token');

    const { t } = useTranslation();
    const navigate = useNavigate()

    const [filters, setFilters] = useFiltersFromLocation();

    function handleFilterChange(field, newValue) {
        setFilters(prevFilters => {

            const items = Array.isArray(prevFilters?.items) ? [...prevFilters.items] : [];
            const index = items.findIndex(item => item.field === field);

            if (index !== -1) {
                items[index] = { ...items[index], value: newValue };
            } else {
                items.push({
                    field,
                    operator: "equals",
                    value: newValue
                });
            }

            // console.info('RunningDashboard handleFilterChange', {
            //     ...prevFilters,
            //     items
            // });

            return {
                ...prevFilters,
                items
            };
        });
    }

    const createRenderCell = (field, handleFilterChange) => (params) => (
        <span
            onClick={(e) => {
                e.stopPropagation();
                handleFilterChange(field, params.value);
            }}
            style={{ cursor: 'pointer', color: 'var(--app-menu-background-flat-text)' }}
        >
            {params.value}
        </span>
    );

    const createSliceFilterHandler = (field, handleFilterChange) => (params) => {

        const detranslation = {
            "In marcia": "running",
            "In fase d'ordine": "in_order",
            "Archiviato": "closed"
        }
        handleFilterChange(field, detranslation[params] ?? params);
    };

    const createTimelineBarFilterHandler = () => (params) => {
        const monthNames = [
            "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno",
            "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"
        ];

        const [monthStr, yearStr] = params.toLowerCase().split(' ');
        const month = monthNames.indexOf(monthStr);
        const year = parseInt(yearStr, 10);

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);

        console.info(end.toISOString())

        const yearStart = start.getFullYear();
        const monthStart = String(start.getMonth() + 1).padStart(2, '0');
        const dayStart = String(start.getDate()).padStart(2, '0');

        const yearEnd = end.getFullYear();
        const monthEnd = String(end.getMonth() + 1).padStart(2, '0');
        const dayEnd = String(end.getDate()).padStart(2, '0');

        let localfilters = {
            items: [
                ...(filters?.items || []),
                {
                    field: "_related_contract_end_at",
                    operator: "between",
                    value: { from: `${yearStart}-${monthStart}-${dayStart}T00:00:00.000Z`, to: `${yearEnd}-${monthEnd}-${dayEnd}T23:58:59.000Z` }
                }
            ]
        }

        const qs = localfilters.items.map(f => {
            const value = typeof f.value === 'object'
                ? encodeURIComponent(JSON.stringify(f.value))
                : encodeURIComponent(f.value);
            return `${encodeURIComponent(f.field)}=${value}`;
        }).join('&');

        navigate('/cars/car?' + qs);
    };

    const getTransposedDateFirstOfMonth = (months) => {
        const today = new Date();
        const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        firstOfMonth.setMonth(firstOfMonth.getMonth() + months);

        const yyyy = firstOfMonth.getFullYear();
        const mm = String(firstOfMonth.getMonth() + 1).padStart(2, '0');
        const dd = String(firstOfMonth.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
    }

    return (
        <Box ref={ref}>
            <Filters filters={filters} setFilters={setFilters} />

            {showKPI &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-kpi">
                    <KPISet filters={filters} />
                </Box>
            }

            {showOverviewByRenter &&
                <Box className="dashboard-menu-itemgroup  dashboard-menu-itemgroup-overview" sx={{ marginTop: '30px' }}>
                    <Overview
                        dataProviderName='statisticsviews/fleet/overviewByRenter'
                        aggregatorLabel={t('renter')}
                        aggregateBy='_related_renter_name'
                        filters={filters}
                        legalEntityClickHandler={createRenderCell('_related_renter_name', handleFilterChange)}
                    />
                </Box>
            }

            {showOverviewByCustomerCluster &&
                <Box className="dashboard-menu-itemgroup  dashboard-menu-itemgroup-overview" sx={{ marginTop: '30px' }}>
                    <Overview
                        dataProviderName='statisticsviews/fleet/overviewByCustomerCluster'
                        aggregatorLabel={t('Profilazione Cliente')}
                        aggregateBy='_related_legalEntity_commercialCluster'
                        filters={filters}
                        legalEntityClickHandler={createRenderCell('_related_legalEntity_commercialCluster', handleFilterChange)}
                    />
                </Box>
            }

            {showOverviewByArea && !user?.data?.roles?.includes('Account') && !user?.data?.roles?.includes('Area manager') &&
                <Box className="dashboard-menu-itemgroup  dashboard-menu-itemgroup-overview" sx={{ marginTop: '30px' }}>
                    <Overview
                        dataProviderName='statisticsviews/fleet/overviewByArea'
                        aggregatorLabel={t('Area commerciale')}
                        aggregateBy='_related_account_area_name'
                        filters={filters}
                        legalEntityClickHandler={createRenderCell('_related_account_area_name', handleFilterChange)}
                    />
                </Box>
            }

            {showOverviewByAccount && !user?.data?.roles?.includes('Account') && !user?.data?.roles?.includes('Executive') &&
                <Box className="dashboard-menu-itemgroup  dashboard-menu-itemgroup-overview" sx={{ marginTop: '30px' }}>
                    <Overview
                        dataProviderName='statisticsviews/fleet/overviewByAccount'
                        aggregatorLabel={t('Azienda proprietario')}
                        aggregateBy='_related_account_name'
                        filters={filters}
                        legalEntityClickHandler={createRenderCell('_related_account_name', handleFilterChange)}
                    />
                </Box>
            }

            {showPIEFleet &&
                <PieFleet user={user} filters={filters} createSliceFilterHandler={createSliceFilterHandler} handleFilterChange={handleFilterChange} t={t} />
            }

            {showPIEAccounting && !user?.data?.roles?.includes('Account') &&
                <PieAccounting user={user} filters={filters} createSliceFilterHandler={createSliceFilterHandler} handleFilterChange={handleFilterChange} t={t} />
            }

            {showPIEExpiration &&
                <Box className="dashboard-section-title">
                    <h2>{t('Distribuzione vetture in scadenza per tipologia cliente')}</h2>
                </Box>
            }

            {showPIEExpiration &&
                <PieExpiration user={user} filters={filters} createSliceFilterHandler={createSliceFilterHandler} handleFilterChange={handleFilterChange} t={t} />
            }


            {showPIETraceKm &&
                <Box className="dashboard-section-title">
                    <h2>{t('Rilevamento KM per tipologia cliente')}</h2>
                </Box>
            }

            {showPIETraceKm &&
                <PieTraceKM user={user} filters={filters} createSliceFilterHandler={createSliceFilterHandler} handleFilterChange={handleFilterChange} t={t} />
            }

            {showPIEPotential &&
                <PiePotential user={user} filters={filters} createSliceFilterHandler={createSliceFilterHandler} handleFilterChange={handleFilterChange} t={t} />
            }

            {showPIEPurchase && false &&
                <PiePurchase user={user} filters={filters} createSliceFilterHandler={createSliceFilterHandler} handleFilterChange={handleFilterChange} t={t} />
            }


            {showTimelineExpiration &&
                <Box className="dashboard-section-title">
                    <h2>{"Calendario Scadenze"}</h2>
                </Box>
            }
            {showTimelineExpiration &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-timeline" sx={{ marginTop: '10px' }}>
                    <Box className="dashboard-menu-item">
                        <Bar
                            dataProviderName="statisticsviews/fleetbytimelinedexpiration/timelined/views_cars_car/_related_contract_end_at/month"
                            //format="currency"
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_contract_end_at",
                                        operator: "between",
                                        value: {
                                            from: getTransposedDateFirstOfMonth(0),
                                            to: getTransposedDateFirstOfMonth(11),
                                        }
                                    }
                                ]
                            }}
                            handleFilterChange={createTimelineBarFilterHandler('_related_contract_end_at', handleFilterChange)}
                        />
                    </Box>
                </Box>
            }

            {showTimelineCommission && false &&
                <Box className="dashboard-section-title">
                    <h2>{t('Commission calendar')}</h2>
                </Box>
            }
            {showTimelineCommission && false &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-timeline" sx={{ marginTop: '10px' }}>
                    <Box className="dashboard-menu-item">
                        <Bar
                            title={t("Commission calendar")}
                            dataProviderName="statisticsviews/fleetbytimelinedexpiration/timelined/views_cars_car/_related_contract_start_at/month/_related_contract_commission"
                            format="currency"
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_contract_start_at",
                                        operator: "after",
                                        value: getTransposedDateFirstOfMonth(0)
                                    }
                                ]
                            }}
                        />
                    </Box>
                </Box>
            }

            {showActionablesExpiration &&
                <Box className="dashboard-section-title">
                    <h2>{t('Vetture in scadenza')}</h2>
                </Box>
            }
            {showActionablesExpiration &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-table">
                    <Box className="dashboard-menu-item dashboard-menu-item-tablewrapper autoheight">
                        <Table
                            dataProviderName={'statisticsviews/cars/contractExpiringYear'}
                            filters={filters}
                            columns={[
                                { field: 'plate', headerName: t('plate'), width: 150 },
                                {
                                    field: '_related_renter_name', headerName: t('renter'), flex: 1,
                                    //renderCell: createRenderCell('_related_renter_name', handleFilterChange),
                                },
                                { field: '_related_contract_end_at', headerName: t('end_at'), flex: 1, "type": "date", valueGetter: (params) => params ? new Date(params) : null },
                                {
                                    field: '_related_legalEntity_name', headerName: t('customer'), flex: 1,
                                    //renderCell: createRenderCell('_related_legalEntity_name', handleFilterChange),
                                },
                                ...(!user?.data?.roles?.includes('Account')
                                    ? [{ field: '_related_account_name', headerName: t('Azienda proprietario'), flex: 1 }]
                                    : [])
                            ]}
                            drawerRouteBase='cars'
                            showAllRoute={'/cars/car?status=running&_related_contract_end_at=' + JSON.stringify({ from: getTransposedDateFirstOfMonth(0), to: getTransposedDateFirstOfMonth(12) })}
                        />
                    </Box>
                </Box>
            }
            {showActionablesKm &&
                <Box className="dashboard-section-title">
                    <h2>{t('Rilevamenti chilometrici')}</h2>
                </Box>
            }
            {showActionablesKm &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-table" sx={{ marginTop: '30px' }}>

                    <Box className="dashboard-menu-item dashboard-menu-item-tablewrapper autoheight">
                        <Table
                            title={t("Rilevamenti KM mancanti")}
                            dataProviderName={'statisticsviews/cars/missingKms'}
                            filters={{
                                items: [
                                    ...(filters?.items?.filter(item => item.field !== "projectedDeltaMileage") || []),
                                    {
                                        field: "projectedDeltaMileage",
                                        operator: "isEmpty",
                                        value: '_'
                                    }
                                ]
                            }}
                            columns={[
                                { field: 'plate', headerName: t('plate'), width: 150 },
                                {
                                    field: '_related_legalEntity_name', headerName: t('customer'), flex: 1,
                                    //renderCell: createRenderCell('_related_legalEntity_name', handleFilterChange),
                                },
                                {
                                    field: '_related_renter_name', headerName: t('renter'), flex: 1,
                                    //renderCell: createRenderCell('_related_renter_name', handleFilterChange),
                                },
                                ...(!user?.data?.roles?.includes('Account')
                                    ? [{ field: '_related_account_name', headerName: t('Azienda proprietario'), flex: 1 }]
                                    : [])
                            ]}
                            drawerRouteBase='cars'
                            showAllRoute={'/cars/car?projectedDeltaMileage=missing'}
                        />
                    </Box>

                    <Box className="dashboard-menu-item dashboard-menu-item-tablewrapper autoheight">
                        <Table
                            title={"Rilevamenti KM in eccesso"}
                            dataProviderName={'statisticsviews/cars/exceedingKms'}
                            filters={{
                                items: [
                                    ...(filters?.items?.filter(item => item.field !== "projectedDeltaMileage") || []),
                                    {
                                        field: "projectedDeltaMileage",
                                        operator: ">",
                                        value: 1001
                                    }
                                ]
                            }}
                            columns={[
                                { field: 'plate', headerName: t('plate'), width: 150 },
                                {
                                    field: '_related_legalEntity_name', headerName: t('customer'), flex: 1,
                                    //renderCell: createRenderCell('_related_legalEntity_name', handleFilterChange),
                                },
                                { field: 'projectedDeltaMileagePercentage', headerName: t('% scostamento'), flex: 1, valueGetter: (params) => params ? params + '%' : null },
                                { field: 'traceKmsLast_at_readable', headerName: t('Data ultima rilevazione'), flex: 1, "type": "date", valueGetter: (params) => params ? new Date(params) : null },

                                ...(!user?.data?.roles?.includes('Account')
                                    ? [{ field: '_related_account_name', headerName: t('Azienda proprietario'), flex: 1 }]
                                    : [])
                            ]}
                            drawerRouteBase='cars'
                            showAllRoute={'/cars/car?projectedDeltaMileage=' + JSON.stringify({ from: 1001, to: 1000000 })}
                        />
                    </Box>

                    <Box className="dashboard-menu-item dashboard-menu-item-tablewrapper autoheight">
                        <Table
                            title={t("Rilevamenti KM in difetto")}
                            dataProviderName={'statisticsviews/cars/tooFewKms'}
                            filters={{
                                items: [
                                    ...(filters?.items?.filter(item => item.field !== "projectedDeltaMileage") || []),
                                    {
                                        field: "projectedDeltaMileage",
                                        operator: "<",
                                        value: -1001
                                    }
                                ]
                            }}
                            columns={[
                                { field: 'plate', headerName: t('plate'), width: 150 },
                                {
                                    field: '_related_legalEntity_name', headerName: t('customer'), flex: 1,
                                    //renderCell: createRenderCell('_related_legalEntity_name', handleFilterChange),
                                },
                                { field: 'projectedDeltaMileagePercentage', headerName: t('% scostamento'), flex: 1, valueGetter: (params) => params ? params + '%' : null },
                                { field: 'traceKmsLast_at_readable', headerName: t('Data ultima rilevazione'), flex: 1, "type": "date", valueGetter: (params) => params ? new Date(params) : null },

                                ...(!user?.data?.roles?.includes('Account')
                                    ? [{ field: '_related_account_name', headerName: t('Azienda proprietario'), flex: 1 }]
                                    : [])
                            ]}
                            drawerRouteBase='cars'
                            showAllRoute={'/cars/car?projectedDeltaMileage=' + JSON.stringify({ from: -1000000, to: -1001 })}
                        />
                    </Box>
                </Box>
            }
        </Box>
    )
})

export default RunningDashboard;
